import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  CircularProgress,
  alpha,
  useTheme,
} from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

const DeleteConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
  yearOfAssessment,
  deleting = false,
}) => {
  const theme = useTheme();
  return (
    <Dialog
      open={open}
      onClose={deleting ? () => {} : onClose}
      maxWidth='sm'
      fullWidth
      PaperProps={{
        sx: {
          p: 2,
          borderRadius: 2,
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.08)",
        },
      }}
    >
      <DialogTitle sx={{ pb: 1 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <WarningAmberIcon sx={{ color: "error.main", fontSize: 28 }} />
          <Typography variant='h6' component='div' sx={{ color: "error.main" }}>
            Delete Tax Computation
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography variant='body1' sx={{ mb: 2 }}>
          Are you sure you want to delete the tax computation for Year of
          Assessment {yearOfAssessment}?
        </Typography>
        <Typography variant='body2' color='error' sx={{ fontWeight: 500 }}>
          This action cannot be undone. All associated data will be permanently
          deleted.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={onClose}
          variant='outlined'
          disabled={deleting}
          sx={{
            borderRadius: 1,
            textTransform: "none",
            px: 3,
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant='contained'
          color='error'
          disabled={deleting}
          startIcon={
            deleting ? (
              <CircularProgress size={18} color='inherit' sx={{ mr: 0.5 }} />
            ) : null
          }
          sx={{
            backgroundColor: deleting
              ? alpha(theme.palette.error.main, 0.35)
              : theme.palette.error.main,
            borderRadius: 1,
            textTransform: "none",
            px: 3,
            "&:hover": {
              backgroundColor: deleting
                ? alpha(theme.palette.error.main, 0.35)
                : theme.palette.error.dark,
            },
            "&.Mui-disabled": {
              backgroundColor: alpha(theme.palette.error.main, 0.35),
              color: theme.palette.error.main,
            },
          }}
        >
          {deleting ? "Deleting..." : "Delete"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationDialog;
